import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import LandingPage from './pages/LandingPage';
import Onboarding from './pages/Onboarding';
import NewCampaign from './pages/NewCampaign';
import Checkout from './pages/Checkout';
import PaymentSuccess from './pages/PaymentSuccess';
import PostPaymentSurvey from './pages/PostPaymentSurvey';
import DashboardNew from './pages/DashboardNew';
import AdminPanel from './pages/AdminPanel';
import GoogleAdsDashboard from './pages/GoogleAdsDashboard';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ToastContainer from './components/Toast';
import '@/App.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    if (token && userData) {
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  const ProtectedRoute = ({ children }) => {
    if (loading) return <div>Loading...</div>;
    return user ? children : <Navigate to="/login" />;
  };

  const AdminRoute = ({ children }) => {
    if (loading) return <div>Loading...</div>;
    return user && user.is_admin ? children : <Navigate to="/dashboard" />;
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login setUser={setUser} />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
          <Route path="/new-campaign" element={<ProtectedRoute><NewCampaign /></ProtectedRoute>} />
          <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
          <Route path="/payment-success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
          <Route path="/post-payment-survey" element={<ProtectedRoute><PostPaymentSurvey /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><DashboardNew user={user} /></ProtectedRoute>} />
          <Route path="/admin" element={<AdminRoute><AdminPanel /></AdminRoute>} />
          <Route path="/google-ads" element={<AdminRoute><GoogleAdsDashboard user={user} /></AdminRoute>} />
        </Routes>
        <ToastContainer />
      </BrowserRouter>
    </div>
  );
}

export default App;